module.exports = __webpack_public_path__ + "static/new-beg-863d62a3186b6c1a807728ea715cdbd9.png";